import LoadingBlock from '@/components/feedback/LoadingBlock';
import { useApiCall } from '@/hooks/useApiCall';
import { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { LocationModel } from '../../types/LocationModel';
import { locationService } from '../../api/locations/location.service';
import { useTranslation } from '@/lib';
import GuestLocationFormLogic from './GuestLocationFormLogic';

const GuestLocationFormApi: FunctionComponent = () => {
  const { locationId } = useParams();
  const locationIdNumber = locationId ? Number.parseInt(locationId) : 0;
  const { t } = useTranslation();

  const { data, isLoading, isError, setApiCallArg } = useApiCall<LocationModel>(() => locationService.getById(0), {
    manual: true,
  });

  useEffect(() => {
    if (locationIdNumber) {
      setApiCallArg(() => locationService.getById(locationIdNumber));
    }
  }, [locationIdNumber]);

  // return early if initial form data isn't loaded
  if (isLoading) return <LoadingBlock />;
  if (isError || !data) return <div>{t('no_data')}</div>;

  return (
    <GuestLocationFormLogic
      initialValues={{
        name: data.dto.name,
        code: data.dto.code,
        description: data.dto.description,
        type: data.dto.type,
        city: data.dto.city,
        country: data.dto.country,
        geofence: data.dto.geofence,
        parentLocationId: data.parentLocationId,
        postalCode: data.dto.postalCode,
        streetName: data.dto.streetName,
        streetNumber: data.dto.streetNumber,
        isSystem: data.dto.isSystem,
        includeInReturnRate: data.dto.includeInReturnRate,
      }}
      locationId={locationIdNumber}
    />
  );
};

export default GuestLocationFormApi;
